const routes = [
  {
    name: 'LoginPage',
    path: '/login',
    component: () => import('@/views/auth/Login.vue')
  },
  {
    name: 'ConfirmationPage',
    path: '/confirmation/:code',
    component: () => import('@/views/auth/Confirmation.vue')
  },
  {
    name: 'RecoverPage',
    path: '/recover',
    meta: { label: '' },
    component: () => import('@/views/auth/Recover.vue')
  }
]
export default routes
